import { __assign } from "tslib";
import React, { Fragment } from 'react';
import { IconSVG } from '../icon-svg/icon-svg';
export var IconInsurance = function (SVGprops) {
    return (React.createElement(IconSVG, __assign({}, SVGprops),
        React.createElement(Fragment, null,
            React.createElement("path", { xmlns: "http://www.w3.org/2000/svg", d: "M11.96 22.04L11.69 21.96C4.09001 19.78 4.01001 11.09 4.01001 11V5.34003L12 1.91003L20 5.34003V11C20 11.09 19.91 19.78 12.23 21.96L11.95 22.04H11.96ZM6.00001 6.66003V11C6.00001 11.29 6.10001 18.07 11.96 19.96C17.93 18.06 18 11.08 18 11V6.66003L12 4.09003L6.00001 6.66003Z" }),
            ' ',
            React.createElement("path", { xmlns: "http://www.w3.org/2000/svg", d: "M11 15.41L8.29001 12.71L9.71001 11.29L11 12.59L15.29 8.29004L16.71 9.71004L11 15.41Z" }))));
};
